import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=39cca9a7&scoped=true"
import script from "./manual.vue?vue&type=script&lang=ts"
export * from "./manual.vue?vue&type=script&lang=ts"
import style0 from "./manual.vue?vue&type=style&index=0&id=39cca9a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cca9a7",
  null
  
)

export default component.exports